import { Article } from './article.model';
import { IMaxbrainImageQuery } from '../../image-library/interfaces/maxbrain-image.interface';
import { MaxbrainImage } from '../../image-library/models/maxbrain-image.model';

/**
 *  Transform Entity Posting to  a future Json Posting Image class
 */
export class ArticleImageCommand implements IMaxbrainImageQuery {
    id: string;
    unsplash: {
        unsplash_id: string;
        author_name: string;
        author_profile_url: string;
        author_profile_image: string;
    };
    url: string;
    small_url: string;
    thumb_url: string;
    large_url: string;

    /**
     * Can be build from Posting or MaxbrainImage
     * @param tempArticle
     * @param image
     */
    constructor(tempArticle?: Article, image?: MaxbrainImage) {
        if (tempArticle) {
            this.id = tempArticle.image.id;
            this.url = tempArticle.image.url;
            this.small_url = tempArticle.image.smallUrl;
            this.thumb_url = tempArticle.image.thumbUrl;
            this.large_url = tempArticle.image.largeUrl;
            if (tempArticle.image.unsplash) {
                this.unsplash = {
                    unsplash_id: tempArticle.image.unsplash.unsplashId,
                    author_name: tempArticle.image.unsplash.authorName,
                    author_profile_url: tempArticle.image.unsplash.authorProfileUrl,
                    author_profile_image: tempArticle.image.unsplash.authorProfileImage,
                };
            }
        } else if (image) {
            this.id = image.id;
            this.url = image.url;
            this.small_url = image.smallUrl;
            this.thumb_url = image.thumbUrl;
            this.large_url = image.largeUrl;

            if (image.unsplash) {
                this.unsplash = {
                    unsplash_id: image.unsplash.unsplashId,
                    author_name: image.unsplash.authorName,
                    author_profile_url: image.unsplash.authorProfileUrl,
                    author_profile_image: image.unsplash.authorProfileImage,
                };
            }
        }
    }
}
